import {
    ADD_CREATE_INVOICE_FAILED,
    ADD_CREATE_INVOICE_LOADING,
    ADD_CREATE_INVOICE_SUCCESS,
    REMOVE_CREATE_INVOICE,
} from "../types";

const initialState = {
    loading: false,
    error: null,
    data: null,
    status: null,
};

export const createInvoiceReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
) => {
    switch (action.type) {
        case ADD_CREATE_INVOICE_LOADING:
            return {
                ...state,
                loading: action.loading,
            };
        case ADD_CREATE_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: "",
                status: action.status,
                error: null,
            };
        case ADD_CREATE_INVOICE_FAILED:

            return {
                ...state,
                loading: false,
                data: null,
                status: action.status,
                error: action.error,
            };
        case REMOVE_CREATE_INVOICE:
            return initialState;
        default:
            return state;
    }
};
